/* Рандомная функция с процентным шансом */
const getByChance = (items, region) => {
  const totalChances = items.reduce((acc, c) => acc + c.dropChance, 0);
  const rnd = totalChances * Math.random();

  if (items.length < 2) {
    return items[0];
  } else {
    items.forEach((item) => {
      item.regions.forEach((el) => {
        if (el.regionId == region && el.link) {
          item.Redirect = true;
        }
      });
    });

    const result = items.filter((item) => item.Redirect);
    if (result.length == 0) {
      for (let i = 0, sum = 0; ; i++) {
        sum += items[i].dropChance;
        if (sum > rnd) return items[i];
      }
    } else if (result.length == 1) {
      return result[0];
    } else {
      for (let i = 0, sum = 0; ; i++) {
        sum += result[i].dropChance;
        if (sum > rnd) return result[i];
      }
    }
  }
};

export default getByChance;
